module.exports = __webpack_public_path__ + "img/zhengshu2.77a105d3.png";